import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateRangeComponent } from './date-range.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [DateRangeComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  exports: [DateRangeComponent],
})
export class DateRangeModule {}
